/// <reference path='../../interfaces/interfaces.d.ts' />

import IToasterService = toaster.IToasterService;
import IScope = angular.IScope;
'use strict';

class RepeatModalController {
    public static $inject = [
        '$scope',
        '$uibModalInstance',
        'event',
        'Calendar',
        'toaster'
    ];

    public occurrences;
    public datePickerConfig;
    public repeatCases: string[];
    public rule: string;
    public start: any;
    public end_recurring_period: Date;
    public ends: string;

    constructor(private $scope: IScope,
                private $uibModalInstance: any,
                private event: IEvent,
                private Calendar: ICalendarService,
                private toaster: IToasterService) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.rule = (event.rule) ? event.rule : undefined;
        this.start = event.startDate;

        this.repeatCases = Calendar.getRepeatCases();

        if (this.event.end_recurring_period !== null) {
            this.ends = 'on';
            this.end_recurring_period = moment(this.event.end_recurring_period).toDate();
            this.checkoccurrences();
        } else {
            this.ends = 'never';
            this.end_recurring_period = undefined;
        }

        $scope.$watch('modal.rule', (newVal: any) => {
            if (newVal === undefined) {
                this.ends = 'never';
            }
        });

        this.datePickerConfig = {
            formatDay: 'd',
            formatDayTitle: 'MMM yyyy',
            showWeeks: false,
            minDate: this.start
        };
    }

    public saveRepeatRule(): void {
        let response: any = {};

        if (this.rule) {
            response.end_recurring_period = (this.ends !== 'never') 
            ? this.end_recurring_period 
            : undefined;
            response.rule = (this.rule === undefined) 
            ? undefined 
            : this.rule;

            if (this.ends === 'on') { 
                response.end_recurring_period.setMinutes(moment(this.start).toDate().getMinutes());
            }

            this.$uibModalInstance.close(response);
            } else {
            this.toaster.pop('warning', '', 'Please select repeat frequency!');
        }
    }

    public occurrencesChange(): void {
        if (this.occurrences > 0) {
            this.occurrences = parseInt(this.occurrences, 10);
            let dateDifferance: number = this.occurrences - 1;
            let newDate: Date = moment(this.start).toDate();

            switch (this.rule) {
                case 'daily': {
                    newDate.setDate(newDate.getDate() + dateDifferance);
                    break;
                }
                case 'weekly': {
                    dateDifferance = this.occurrences * 7 - 1;
                    newDate.setDate(newDate.getDate() + dateDifferance);
                    break;
                }
                case 'monthly': {
                    newDate.setMonth(newDate.getMonth() + dateDifferance);
                    break;
                }
                case 'yearly': {
                    newDate.setFullYear(newDate.getFullYear() + dateDifferance);
                    break;
                }
                default: { 
                    break;
                }
            }

            newDate.setMinutes(newDate.getMinutes() + 1);
            this.end_recurring_period = newDate;
        } else {
            this.occurrences = undefined;
            this.toaster.pop('warning', 'Validation Failed', 'Event occurrences count must be a positive number!');
        }
    }

    public checkoccurrences(): void {
        let dateDifferance: number = ((moment(this.end_recurring_period).diff(this.start)) - 60000) / 86400000;
        if (dateDifferance % 1 === 0) {

            dateDifferance += 1;
            switch (this.rule) {
                case 'daily': {
                    this.occurrences = dateDifferance;
                    break;
                }
                case 'weekly': {
                    this.occurrences = dateDifferance / 7;
                    break;
                }
                case 'monthly': {
                    this.occurrences = dateDifferance;
                    break;
                }
                case 'yearly': {
                    this.occurrences = dateDifferance;
                    break;
                }
                default: { 
                    break;
                }
            }

            this.ends = 'after';
        }
    }
}

angular.module('beneple.calendar').controller('RepeatModalController', RepeatModalController);



// WEBPACK FOOTER //
// ./frontend/scripts/calendar/controllers/repeatModal.controller.ts